import PropTypes from "prop-types";
import React, { Component, useState } from "react";
import QRCodePopup from './QRCodePopup';
import { withTranslation } from "react-i18next";
import {
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    Row,
    Card,
    CardBody,
    CardHeader,
} from "reactstrap";
import { Form, Formik } from "formik";
import RavenFormikField from "components/Common/RavenFormikField";
import {
    getInitValue,
} from "components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";
import * as Yup from "yup";

class LinkPaymentShare extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            emailEnabled: true,
            smsEnabled: false,
            showPopup: false
        };

    }

    onChangeSmsRadioButton = (e, data) => {
        this.setState({ smsEnabled: e, emailEnabled: !e });
    }

    onChangeEmailRadioButton = (e, data) => {
        this.setState({ emailEnabled: e, smsEnabled: !e });
    }

    linkCopy = () => {
        if (textRef.current) {
            // Textbox değerini seçip kopyala
            textRef.current.select();
            document.execCommand("copy");
            alert("Metin kopyalandı: " + textRef.current.value);
        }
    };
    render() {
        const { record, formOnSubmitMiddleware, formSubmitButtonRef } = this.props;
        const { emailEnabled, smsEnabled } = this.state;

        return (
            <React.Fragment>
                <Modal
                    isOpen={this.props.show}
                    size="lg"
                    toggle={this.props.onCloseClick}
                    centered={false}
                >
                    <ModalHeader toggle={this.toggle} tag="h4">
                        {this.props.t("sharePaymentLink")}
                    </ModalHeader>
                    <ModalBody>
                        <Formik
                            enableReinitialize={true}
                            initialValues={{
                                guid: getInitValue(
                                    record,
                                    record.guid,
                                ),
                                merchantGuid: getInitValue(
                                    record,
                                    record.merchantGuid,
                                ),
                                merchantId: getInitValue(
                                    record,
                                    record.merchantId,
                                ),
                                linkUrl: getInitValue(
                                    record,
                                    record.linkUrl
                                ),
                                userName: localStorage.getItem("username"),
                                emailOrPhoneValue: "",
                                smsEnabled: smsEnabled,
                                emailEnabled: emailEnabled

                            }}
                            validationSchema={Yup.object().shape({
                                emailOrPhoneValue: Yup.string().required(this.props.t("mustBe")),
                            })}
                            onSubmit={formOnSubmitMiddleware}
                            innerRef={this.formRef}
                        >
                            {({
                                errors,
                                status,
                                touched,
                                values,
                                setFieldValue,

                            }) => (
                                <Form>
                                    <fieldset>
                                        <Card>
                                            <CardHeader className="mdi mdi-monitor-share" style={{ fontSize: "1.5em" }}>
                                                {this.props.t("sharePaymentLinkMessage")}
                                            </CardHeader>
                                            <CardBody>

                                                <div className="d-flex align-items-center" style={{ gap: "10px", flexWrap: "nowrap" }}>
                                                    <div style={{ flexGrow: 1 }}>
                                                        <RavenFormikField
                                                            errors={errors}
                                                            touched={touched}
                                                            name={"linkUrl"}
                                                            label={"linkUrl"}
                                                            type="text"
                                                            style={{ width: "100%" }}
                                                        />
                                                    </div>

                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        style={{ height: "44px", whiteSpace: "nowrap" }}
                                                        onClick={() => navigator.clipboard.writeText(values.linkUrl)}
                                                    >
                                                        {this.props.t("copy")}
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        style={{ height: "44px", whiteSpace: "nowrap" }}
                                                        onClick={() => this.setState({ showPopup: true })}
                                                    >
                                                        {this.props.t("qrCreate")}
                                                    </button>

                                                    <QRCodePopup
                                                        isOpen={this.state.showPopup}
                                                        onClose={() => this.setState({ showPopup: false })}
                                                        url={values.linkUrl}
                                                    />
                                                </div>

                                                <Row>

                                                    <Col lg={2} className="col-2">
                                                        <RavenFormikField
                                                            errors={errors}
                                                            touched={touched}
                                                            name={"email"}
                                                            label={"email"}
                                                            component="radiobutton"
                                                            checked={emailEnabled}
                                                            onChange={e => {
                                                                this.onChangeEmailRadioButton(e, values);
                                                            }}
                                                            disabled={this.state.isDetail}
                                                        />
                                                    </Col>
                                                    <Col lg={2} className="col-2">
                                                        <RavenFormikField
                                                            errors={errors}
                                                            touched={touched}
                                                            name={"sms"}
                                                            label={"sms"}
                                                            component="radiobutton"
                                                            checked={smsEnabled}
                                                            onChange={e => {
                                                                this.onChangeSmsRadioButton(e, values);
                                                            }}
                                                            disabled={this.state.isDetail}
                                                        />
                                                    </Col>

                                                </Row>
                                                <Row>
                                                    <Col lg={8} className="col-8">
                                                        <RavenFormikField
                                                            errors={errors}
                                                            touched={touched}
                                                            name={"emailOrPhoneValue"}
                                                            label={smsEnabled ? this.props.t("sms") : this.props.t("email")}
                                                            type="text"

                                                        />
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>


                                    </fieldset>

                                    <Row>
                                        <Col>
                                            <div
                                                style={{
                                                    textAlign: "right",
                                                }}
                                            >
                                                <button
                                                    ref={formSubmitButtonRef}
                                                    type="submit"
                                                    className="btn btn-danger me-2"

                                                >
                                                    {smsEnabled ? this.props.t("sendSMS") : this.props.t("sendEmail")}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary me-2"
                                                    onClick={this.props.onCloseClick}
                                                >
                                                    {this.props.t("cancel")}
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            )}
                        </Formik>
                    </ModalBody>
                </Modal>
            </React.Fragment>
        );
    }
}

LinkPaymentShare.propTypes = {
    onDeleteName: PropTypes.any,
    onCloseClick: PropTypes.func,
    record: PropTypes.any,
    show: PropTypes.any,
    linkPaymentShareModal: PropTypes.any,
    t: PropTypes.any,
    formOnSubmitMiddleware: PropTypes.any,
    formSubmitButtonRef: PropTypes.any,
};

export default withTranslation()(LinkPaymentShare);
